import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BLUE_500, getTestId, InfoIcon, isValidObject, Tooltip, Typography, useBreakpoint } from '@airtel/air-design-system';
import { Pressable, View } from 'react-native';
import { getPlanInfoSectionStyles } from './PlanInfoSectionStyles';
import { useState } from 'react';
import { BLACK_700, BLACK_900 } from '@airtel/air-design-system/lib/constants/colors';
import Timer from '../timer/Timer';
export var PlanInfoSection = props => {
  var _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'PlanInfoSection' : _props$testID,
    style = props.style,
    planNameProps = props.planNameProps,
    planSubTitleProps = props.planSubTitleProps,
    planDescriptionProps = props.planDescriptionProps,
    infoIconProps = props.infoIconProps,
    infoIconToolTipProps = props.infoIconToolTipProps,
    planSubTitleContainerStyle = props.planSubTitleContainerStyle,
    planInfoTitleContainerStyle = props.planInfoTitleContainerStyle,
    _props$timerProps = props.timerProps,
    timerProps = _props$timerProps === void 0 ? {} : _props$timerProps;
  var _useState = useState(false),
    showToolTip = _useState[0],
    setShowTooltip = _useState[1];
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true
    }),
    isSmallScreen = _useBreakpoint.isSmallScreen;
  var planInfoSectionStyles = getPlanInfoSectionStyles();
  var onInfoIconPress = () => {
    setShowTooltip(prev => !prev);
  };
  return _jsxs(View, Object.assign({}, getTestId(testID), {
    style: [style]
  }, {
    children: [_jsxs(View, Object.assign({
      style: [planInfoSectionStyles.planTitleContainerStyle, planInfoTitleContainerStyle]
    }, {
      children: [!!isValidObject(planNameProps) && _jsx(Typography, Object.assign({
        type: isSmallScreen ? 'body-single-line-lg-bold' : 'body-single-line-xl-bold'
      }, planNameProps)), !!isValidObject(timerProps) && _jsx(Timer, Object.assign({}, timerProps))]
    })), !!isValidObject(planSubTitleProps) && _jsxs(View, Object.assign({
      style: [planInfoSectionStyles.planSubtitleContainerStyle, planSubTitleContainerStyle],
      testID: testID + '_planSubTitle'
    }, {
      children: [_jsx(Typography, Object.assign({
        style: planInfoSectionStyles.planSubTitleStyle,
        color: BLACK_900,
        testID: testID + '_planSubTitle_text'
      }, planSubTitleProps)), !!isValidObject(infoIconProps) && (infoIconProps === null || infoIconProps === void 0 ? void 0 : infoIconProps.showIcon) && _jsx(Tooltip, Object.assign({
        isVisible: showToolTip,
        style: planInfoSectionStyles.infoIconToolTipStyle
      }, infoIconToolTipProps, {
        testID: testID + '_planSubTitle_tooltip',
        onClose: onInfoIconPress
      }, {
        children: _jsx(Pressable, Object.assign({
          onPress: onInfoIconPress
        }, {
          children: _jsx(InfoIcon, Object.assign({
            color: BLUE_500,
            fontSize: 20
          }, infoIconProps, {
            testID: testID + '_planSubTitle_tooltip_infoicon'
          }))
        }))
      }))]
    })), !!isValidObject(planDescriptionProps) && _jsx(Typography, Object.assign({
      type: isSmallScreen ? 'body-para-sm' : 'body-para-md',
      color: BLACK_700,
      numberOfLines: 2,
      testID: testID + '_planDescription_text'
    }, planDescriptionProps))]
  }));
};